module.exports = __webpack_public_path__ + "static/media/Insta-Clone.15d2f7ac.png";